import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import BookingService from "../../services/bookingService";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";

const TicketCheck: React.FC = () => {
  const [bookNo, setBookNo] = useState("");
  const [contactType, setContactType] = useState("");
  const [contactValue, setContactValue] = useState("");
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState<"success" | "fail"| "info">("success");
  const emailInputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  const mutation = useMutation(
    async () => {
      return await BookingService.checkTicket({
        bookNo: bookNo,
        contact: contactValue,
        contactType: contactType,
      });
    },
    {
      onSuccess: (data) => {
        setPopupType("success");
        setPopupMessage("We have resent your ticket information to your email.　　　Please check the email address provided above.")
        setIsPopupOpen(true);
      },
      onError: (error: any) => {
        setPopupType("fail");
        setPopupMessage("");
        setIsPopupOpen(true);
      },
    },
  );
  // Regular expressions for validation
  const emailRegex = /^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*$/;
  const phoneRegex = /^[0-9]{10,15}$/; // Assuming a 10-15 digit phone number

  // Validation function
  const validateForm = () => {
    // Validate Book Number (ensure it's filled and a number)
    if (!bookNo) {
      setPopupMessage(t("Please enter a valid Book No"));
      setPopupType("fail");
      setIsPopupOpen(true);
      return false;
    }

    // Validate based on selected contact type
    if (contactType === "Email" && !emailRegex.test(contactValue)) {
      setPopupMessage(t("Please enter a valid Email"));
      setPopupType("fail");
      setIsPopupOpen(true);
      return false;
    }

    if (contactType === "Phone" && !phoneRegex.test(contactValue)) {
      setPopupMessage(t("Please enter a valid Phone number"));
      setPopupType("fail");
      setIsPopupOpen(true);
      return false;
    }
    return true;
  };
  // **Submit Handler**
  const handleSubmit = () => {
    if (validateForm()) {
      mutation.mutate();
    }
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const getTicket = useMutation(
    async () => {
      const email = emailInputRef.current?.value;
      if (!email) {
        throw new Error("Email is required"); // Throw an error if email is empty or null
      }
      return await BookingService.getTicket({
        subject: "abc",
        email,
        infoTicket:
          "at [Source: REDACTED (`StreamReadFeature.INCLUDE_SOURCE_IN_LOCATION` disabled); line: 5, column: 1]",
      });
    },
    {
      onSuccess: (data) => {
        setPopupType("success");
        setIsPopupOpen(true);
        navigate(`/ticket-check/booking-info/${bookNo}`);
      },
      onError: (error: any) => {
        setPopupType("fail");
        setIsPopupOpen(true);
      },
    },
  );

 const handleForgetBookNo = useMutation(
  async () => {
    const email = emailInputRef.current?.value ||'';
    if (!emailRegex.test(email)) {
      throw new Error("Please enter a valid Email"); // Throw an error if email is empty or null
    }
    return await BookingService.forgetTicket({
      email
    });
  },
  {
    onSuccess: (data) => {
      setPopupType("success");
      setPopupMessage("We have resent your ticket information to your email.　　　Please check the email address provided above.")
      setIsPopupOpen(true);

    },
    onError: (error: any) => {
      setPopupMessage(t("Ticket information not found. Please check your details and try again."));
      setPopupType("fail");
      setIsPopupOpen(true);
    },
  },

 )
 const openModalForgetBookNo = () => { 
  setPopupType("info");
  setIsPopupOpen(true);
  
 }
  const isFormValid =
    bookNo && contactType && contactValue;

  return (
    <div className="mx-auto flex items-center justify-center px-6 py-[2.5rem] sm:max-w-[75rem] sm:px-0">
      <div className="w-[44.375rem]">
        <div className="flex justify-between">
          <h1 className="decoration-skip-ink-auto text-left font-sans font-semibold sm:text-[1.875rem] sm:leading-[2.5rem]">
            {t("Information ticket")}
          </h1>
          <button
            onClick={openModalForgetBookNo}
            type="button"
            className="font-noto-sans decoration-none rounded-[3.125rem] border border-[#232323] bg-white px-4 py-2 text-center text-sm font-semibold text-[#232323] opacity-100 hover:bg-gray-100 focus:ring-2 focus:ring-gray-200 sm:w-[11.25rem] sm:py-[0.9375rem] sm:text-base sm:leading-5"
          >
            {t("Forget Book No")}
          </button>
        </div>
        <form className="space-y-[2.5rem]">
          <div>
            <label
              htmlFor="bookNo"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Book no")}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="bookNo"
              value={bookNo}
              onChange={(e) => setBookNo(e.target.value)}
              placeholder={t("Please enter book no")}
              className="h-[3.125rem] w-full rounded-[0.625rem] border border-gray-300 px-4 shadow-sm focus:border-[#DCDCDC] focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              {t("Select Email or Phone number")}
              <span className="text-red-500">*</span>
            </label>
            <div className="mt-1 flex flex-wrap items-center gap-[0.5rem] sm:flex-nowrap">
              <select
                value={contactType}
                onChange={(e) => setContactType(e.target.value)}
                className="wei-1 h-[3.125rem] w-[15rem] rounded-[0.625rem] border border-gray-300 px-4 shadow-sm focus:border-[#DCDCDC] focus:outline-none focus:ring-[#DCDCDC]"
              >
                <option value="" disabled selected hidden>
                  {t("Please Select")}
                </option>
                <option value={"email"}>{t("Email")}</option>
                <option value={"phone"}>{t("Phone")}</option>
              </select>
              <input
                type="text"
                value={contactValue}
                onChange={(e) => setContactValue(e.target.value)}
                className="h-[3.125rem] w-full rounded-[0.625rem] border border-gray-300 px-4 shadow-sm focus:border-[#DCDCDC] focus:outline-none"
                placeholder=""
              />
            </div>
          </div>
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={!isFormValid} // Disable button if the form is invalid
              className={`w-[11.25rem] rounded-[3.125rem] py-[0.9375rem] text-center focus:ring-gray-200 ${
                isFormValid
                  ? "bg-[#A8C6FF] text-black"
                  : "bg-[#BFC5C9] text-[#FFFFFF]"
              }`}
            >
              {t("Check")}
            </button>
          </div>
        </form>
      </div>

      {isPopupOpen && popupType === "success" && (
       <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
       <div className="popup-modal w-[22.5rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
         <div className="text-center">
           <div className="mb-4 flex justify-center">
             <img
              src="../../../../assets/icons/success-icon.svg"
               className="h-[3rem] w-[3rem] rounded-[0.5rem] object-cover"
               alt="warning icon"
             />
           </div>
           <p className="mb-6 text-lg">
             {t(popupMessage ? popupMessage :
               "Request successfully",
             )}
           </p>
           <div className="flex justify-between space-x-4">
             <button
               onClick={closePopup}
               className="flex h-[3rem] w-[18.5rem] items-center justify-center rounded-[3.125rem] bg-primary text-base font-normal text-[#232323]"
             >
               {t("Ok")}
             </button>
           </div>
         </div>
       </div>
     </div>
      )}

      {isPopupOpen && popupType === "fail" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="popup-modal w-[22.5rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
            <div className="text-center">
              <div className="mb-4 flex justify-center">
                <img
                  src="../../../assets/icons/warning.svg"
                  className="h-[3rem] w-[3rem] rounded-[0.5rem] object-cover"
                  alt="warning icon"
                />
              </div>
              <p className="mb-6 text-lg">
                {t(popupMessage ? popupMessage :
                  "Ticket information not found. Please check your details and try again.",
                )}
              </p>
              <div className="flex justify-between space-x-4">
                <button
                  onClick={closePopup}
                  className="flex h-[3rem] w-[18.5rem] items-center justify-center rounded-[3.125rem] bg-primary text-base font-normal text-[#232323]"
                >
                  {t("Check")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
       {isPopupOpen && popupType === "info" && (
         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
         <div className="popup-modal w-[22.5rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
           <div className="text-center">
             <div>
               <label
                 htmlFor="email"
                 className="mb-[0.625rem] block text-start text-sm font-medium"
               >
                 {t("Email")}
               </label>
               <input
                 ref={emailInputRef}
                 type="text"
                 placeholder={t("Please enter your email")}
                 className="w-full rounded-[0.625rem] border border-gray-300 px-4 py-2 shadow-sm focus:border-[#DCDCDC] focus:outline-none"
               />
             </div>
             <div className="mt-[1.25rem] flex justify-between space-x-4">
               <button
                 className="h-[3rem] w-[18.5rem] rounded-[3.125rem] bg-[#E9EAEB] text-base font-normal text-[#232323]"
                 onClick={closePopup}
               >
                 {t("Cancel")}
               </button>
               <button
                 onClick={() => handleForgetBookNo.mutate()}
                 className="flex h-[3rem] w-[18.5rem] items-center justify-center rounded-[3.125rem] bg-primary text-base font-normal text-[#232323]"
               >
                 {t("Send")}
               </button>
             </div>
           </div>
         </div>
       </div>
      )}
    </div>
  );
};

export default TicketCheck;
